// Uncomment the below to migrate to statefull component
// import NotFoundContainer from './NotFoundContainer'
import NotFound from './NotFound'

export { NotFound }
export default NotFound
// Uncomment the below to migrate to statefull component
// export { NotFoundContainer }
// export default { NotFoundContainer }



// WEBPACK FOOTER //
// ./src/pages/NotFound/index.js